import { getDropdownOptions } from '@ben/columbia/api';
import Select, { type ISelect } from '@ben/orion/deprecated-select';
import { Loader } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { forwardRef, memo, useMemo } from 'react';
import styled from 'styled-components';

interface IModelDropdown extends Omit<ISelect, 'onChange' | 'options'> {
  apiName: string;
  selected?: number;
  onChange: (pk: number) => void;
  hasError?: boolean;
  width?: string;
}

const ModelDropdown = forwardRef(
  (
    {
      onChange,
      selected,
      apiName,
      hasError,
      width,
      name,
      ...rest
    }: IModelDropdown,
    ref
  ) => {
    const { isLoading, data } = useQuery(
      [`dropdownOptionsFor-${apiName}`],
      () => getDropdownOptions(apiName)
    );

    const options = useMemo(() => {
      return isLoading || !data
        ? []
        : data?.map((item) => ({ key: item.id.toString(), label: item.name }));
    }, [data, isLoading]);

    return (
      <LoaderWrapper>
        <Select
          {...rest}
          ref={ref}
          name={name}
          showSearch={!isLoading}
          defaultValue={selected?.toString() ?? undefined}
          options={options}
          onChange={(selection) => {
            onChange(Number.parseInt(selection as string));
          }}
          hasError={hasError}
          width={width}
          disabled={isLoading}
        />
        {isLoading ? <InlineLoader size="xs" /> : null}
      </LoaderWrapper>
    );
  }
);

ModelDropdown.displayName = 'ModelDropdown';

export default memo(ModelDropdown);

const LoaderWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

const InlineLoader = styled(Loader)`
  margin-left: 8px;
`;
